











//
// WARNING
// This file is auto-generated by Queries.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Queries.tst.
//

import { Type, Transform } from "class-transformer";
import { CancelToken } from 'axios'
import * as moment from 'moment'
import * as qrs from '@/modules/qrs'

import {
    Query,
    IPaginatedQuery, SearchDirection, ProtectedMemory,
    QueryExecutor, PaginatedQueryExecutor
} from '@/modules/qrs'

import {
    IOrderableQuery, IOrderByDescriptor, IOrderBySelectorFn, OrderByConfig, IOrderableProperties,
    OrderableQueryExecutor, OrderablePaginatedQueryExecutor
} from '@/modules/qrs/extensions/orderable'


    

    @Query('AllUserQuery')
    
    export class AllUserQuery  {
        constructor(  ) {
            
        }

        

        

        

        
            /**
            * Returns an instance of a simple QueryExecutor for this query.
            */
            public static getExecutor( query?: AllUserQuery ) {
                return new QueryExecutor<AllUserQuery, MultiUserResult>(MultiUserResult, query);
            }

            

            
        
    }

    

    
        /**
        * The result model for AllUserQuery.
        */
        export class MultiUserResult {
            
                
                 userId: number;
            
                
                 firstName: string;
            
                
                 lastName: string;
            
        }
    

    /**
    * Extraneous types
    */
    export namespace AllUserQuery.ExtraneousTypes {
        

        
    }

